import React from 'react';
import { Container } from 'react-bootstrap';
import { DATENSTAND } from "../../config/constants";
import datengrundlageImg1 from '../../assets/data/images/datengrundlage_m.jpg';
import datengrundlageImg2 from '../../assets/data/images/datengrundlage2_m.png';

const DatengrundlageM = () => {
  return (
    <>
      <style>
        {`
          .datengrundlage-figure-right,
          .datengrundlage-figure-left {
            max-width: 50%;
            margin-top: 20px;
            margin-bottom: 16px;
          }

          .datengrundlage-figure-right {
            float: right;
            margin-left: 20px;
          }

          .datengrundlage-figure-left {
            float: left;
            margin-right: 20px;
          }

          .datengrundlage-figure-right img,
          .datengrundlage-figure-left img {
            width: 100%;
            border-radius: 6px;
          }

          .datengrundlage-figure-right figcaption,
          .datengrundlage-figure-left figcaption {
            font-style: italic;
            font-size: 0.9rem;
            margin-top: 5px;
          }

          .aktuelles-text::after {
            content: "";
            display: block;
            clear: both;
          }

          @media (max-width: 768px) {
            .datengrundlage-figure-right,
            .datengrundlage-figure-left {
              float: none;
              max-width: 100%;
              margin-left: 0;
              margin-right: 0;
            }
          }
        `}
      </style>

      <Container className="mt-4">
        <h2 className="section-title">Datengrundlage</h2>
        <div className="section-title-underline"></div>

        <div className="aktuelles-text">
          <p>
            Der Datensatz für die Auswertungen des interaktiven Berichts beinhaltet die an das KR-LSA gemeldeten und verarbeiteten Daten über 
            Tumorerkrankungen und deren Verläufe von erwachsenen Erkrankten (≥ 18 Jahre), die ihren Wohnsitz in Sachsen-Anhalt haben und/oder im Land behandelt wurden. 
            Diese Daten basieren auf dem bundeseinheitlichen onkologischen Basisdatensatz (oBDS; www.basisdatensatz.de). 
            In den Analysen wurden Angaben über Diagnosen des Primärtumors sowie dessen Therapien innerhalb eines Jahres und Informationen zu 
            Nachsorge und Verlauf der Erkrankung für 2 Jahre berücksichtigt. Eingeschlossen wurden alle Fälle deren Diagnose in den Jahren 2018 bis 2023 erfolgte. 
            Für die Berechnung der Neuerkrankungsraten wurden außerdem Fälle berücksichtigt,
            die ausschließlich durch Verarbeitung von Todesbescheinigungen bekannt geworden sind (DCN-Fälle, „death certificate notified“).
          </p>

          <figure className="datengrundlage-figure-right">
            <img
              src={datengrundlageImg1}
              alt="Datengrundlage und Ausschlusskriterien"
            />
            <figcaption>
              Datengrundlage und Ausschlusskriterien für klinische und epidemiologische Auswertungen im vorliegenden Bericht*
            </figcaption>
          </figure>

          <p>
            Die methodische Grundlage für die Krebsregistrierung und alle Auswertungen bilden „Das Manual der Krebsregistrierung“ <strong>[1]</strong>, 
            die Empfehlungen vom Europäischen Netzwerk der Krebsregister (ENCR) und der Internationalen Vereinigung der Krebsregister (IACR) 
            sowie die Beschlüsse der Plattform §65c (Expertengremium der klinischen Krebsregister Deutschlands). 
            Aus Gründen der Leserlichkeit werden nur relevante Definitionen erläutert und abweichende Regeln beschrieben.
          </p>

          <p>
            Für die epidemiologischen Auswertungen werden ausschließlich die Daten derjenigen Erkrankten ausgewertet, 
            die ihren Wohnsitz zum Zeitpunkt der Diagnose in Sachsen-Anhalt hatten (Wohnortbezug). 
            Bei der Zählung von multiplen Tumoren wird hierbei die sogenannte epidemiologische Zählweise angewendet. 
            Wurde beispielsweise bei einer Patientin ein duktales Mammakarzinom 2015 auf der linken Seite und 2020 ein Karzinom derselben
            Histologiegruppe auf der rechten Seite diagnostiziert, wird das Karzinom für das Jahr 2020 im Gegensatz zur klinischen Auswertung
            für die epidemiologischen Auswertungen nicht berücksichtigt. Die Fälle werden unabhängig davon gezählt, ob sie als DCN-Fälle, 
            alleinige Pathologiemeldungen oder ausschließlich durch Meldungen aus anderen Landeskrebsregistern gemeldet worden sind.
          </p>

          <figure className="datengrundlage-figure-left">
            <img
              src={datengrundlageImg2}
              alt="Meldungen und Teilpopulationen"
            />
            <figcaption>
              Meldungen und Teilpopulationen als Datengrundlage für den vorliegenden Bericht*
            </figcaption>
          </figure>

          <p>
            Die epidemiologischen Auswertungen dienen vor allem dazu, zu bestimmen, wie häufig Krebserkrankungen in einer Region vorkommen. 
            Es werden Daten über das Auftreten von Krebserkrankungen und somit deren Häufigkeit, ihre Verteilung nach Wohnort,
            Geschlecht und Alter der Erkrankten erhoben. Diese Erhebungen erlauben Schätzungen zu Inzidenz, Prävalenz und Mortalität
            der verschiedenen Krebserkrankungen.
          </p>

          <p>
            Die klinischen Auswertungen werden behandlungsortbezogen vorgenommen. 
            Das heißt, dass Meldungen zu allen Tumorerkrankten, die in Sachsen-Anhalt diagnostiziert und/oder behandelt wurden, 
            eingeschlossen wurden, auch wenn sie ihren Wohnsitz zum Zeitpunkt der Diagnose nicht in Sachsen-Anhalt hatten. 
            Für einen Teil der Fälle liegen dem KR-LSA keine klinischen Informationen vor, z.B. bei alleinigen Pathologiemeldungen oder DCN-Fällen.
            Diese Fälle werden bei allen klinischen Auswertungen ausgeschlossen. Die klinischen Auswertungen dienen vor allem dazu, die Behandlungsqualität zu beschreiben.
          </p>

          <p>
            Da in diesem Bericht sämtliche Analysen geschlechtsgetrennt durchgeführt wurden, werden ausschließlich Tumorerkrankungen von Frauen und Männern untersucht. 
            Personen mit nichtbinärem Geschlecht werden wegen sehr kleiner Fallzahlen aus den Analysen ausgeschlossen, um den Datenschutz zu wahren und das Reidentifikationsrisiko zu minimieren.
          </p>

          <p>
            Den Auswertungen liegt der Datenstand vom {DATENSTAND} zugrunde. 
            Es wurde die Statistiksoftware R, Version 4.3.2 verwendet.
          </p>

          <div className="mt-4 pt-3 border-top" style={{ fontSize: "0.95rem" }}>
            <h6>Referenzen</h6>

            <p className="mb-1">
              <strong>[1]</strong> Das Manual der Krebsregistrierung. C. Stegmaier, S. Hentschel, F. Hofstädter u.a. Zuckschwerdt Verlag, München, 2018.
            </p>

            <p className="mb-1">
              <strong>*</strong>Illustrationen und Abbildungen: Friederike Arndt,{" "}
              <a href="https://www.formenorm.de" target="_blank" rel="noopener noreferrer">
                www.formenorm.de
              </a>
            </p>
          </div>
        </div>
      </Container>
    </>
  );
};

export default DatengrundlageM;